import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  BiContextProvidedValue,
  BiData,
  DefaultBiEvent,
} from '@wix/da-bi/pkg/events';
import { Url } from '@wix/da-url';
import BaseTierUpsell from './BaseTierUpsell';

export interface Props {
  className?: string;
  authorName?: string;
}

export const ExploreMoreTierUpsell: React.FC<Props> = ({
  className,
  authorName,
}) => {
  const { t } = useTranslation();
  return authorName ? (
    <BaseTierUpsell
      className={className}
      imageSrc={Url.staticCDNLink(
        'eclipse/global/svg/tier-upsell-explore-more.svg?1'
      )}
      imageWidth="113px"
      title={t('deviation.tier.upsell.title.exploreMore', { authorName })}
      subtitle={t('deviation.tier.upsell.subtitle.exploreMore')}
      buttonText={t('deviation.tier.upsell.button.exploreMore')}
      href={Url.userLink(authorName)}
      biData={BiData<DefaultBiEvent>({
        evid: 2,
        click_info: 'tier.upsell.explore_more',
        sectionname: BiContextProvidedValue,
        widgetname: BiContextProvidedValue,
        typeid: BiContextProvidedValue,
        itemid: BiContextProvidedValue,
      })}
    />
  ) : null;
};
ExploreMoreTierUpsell.displayName = 'ExploreMoreTierUpsell';

export default ExploreMoreTierUpsell;
